import { z } from 'zod';
import { FREEZER_PORTIONS_MAX, FreeMealItemsSchema, FreeMealTitleSchema } from './meal-requests.js';
// ---------------------------------------------------------------------------
// Meal (individual meal, day by day)
// ---------------------------------------------------------------------------
export const MealTypeSchema = z.enum(['lunch', 'dinner']);
export const MealSchema = z.object({
    id: z.string().uuid(),
    family_id: z.string().uuid(),
    date: z.string().date(),
    meal_type: MealTypeSchema,
    /** NULL on a free meal, and on a table set before anything is chosen. */
    recipe_id: z.string().uuid().nullable(),
    /** Name of a meal planned without a recipe; NULL beside a recipe. */
    title: FreeMealTitleSchema.nullable().default(null),
    shopping_items: FreeMealItemsSchema.default([]),
    /** Family member ids (`family_members.id`); empty means the whole household. */
    member_ids: z.array(z.string().uuid()).default([]),
    guest_count: z.number().int().nonnegative().default(0),
    /** Portions cooked for the freezer, on top of the tables; counted in `servings`. */
    freezer_portions: z.number().int().min(0).max(FREEZER_PORTIONS_MAX).default(0),
    /** Set by hand: `member_ids` overrides the members' usual weeks. */
    attendance_manual: z.boolean().default(false),
    source_meal_id: z.string().uuid().nullable().optional(),
    servings: z.number().int().positive(),
    servings_manual: z.boolean().default(false),
    notes: z.string().max(500).nullable().default(null),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});
//# sourceMappingURL=meal.js.map